import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this._boundShow = this.onShow.bind(this);
    this.element.addEventListener("show.bs.modal", this._boundShow);
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this._boundShow);
  }

  onShow(event) {
    const trigger = event.relatedTarget;
    if (!trigger) return;

    this.formTarget.setAttribute("action", trigger.dataset.stepUpUrl);
    const input = this.formTarget.querySelector("[name='otp_code']");
    if (input) input.value = "";
  }
}
